module.exports = __webpack_public_path__ + "media/images/icon-steps-completed-db131c36e468d6df9e34e567f3daa514.svg";